import { OrderBook } from "@cede/types";
import { create } from "zustand";

type OrderBookWithExchangeIdAndPairSymbol = OrderBook & {
  exchangeId: string;
  pairSymbol: string;
};

type OrderBookStore = {
  orderBook: OrderBookWithExchangeIdAndPairSymbol | null;
  setOrderBook: (orderBook: OrderBookWithExchangeIdAndPairSymbol | null) => void;
};

export const useOrderBookStore = create<OrderBookStore>((set) => ({
  orderBook: null,
  setOrderBook: (orderBook: OrderBookWithExchangeIdAndPairSymbol | null) => set({ orderBook }),
}));
